// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SideMenu_wrap__PuHxj","block":"SideMenu_block__hwxXM","wrap-banner":"SideMenu_wrap-banner__ZFCcY"};